const en = {
	language: {
		language: 'CN',
	},
	nav: {
		text1: 'Please enter keywords',
		text2: 'Category',
		text3: 'Certifications',
		text4: 'Please enter keywords',
		text5: 'Product Center',
		text6: 'Home',
	},
	footer: {
		text1: 'Headquarters Address: ',
		text2: 'Production Address: NO.30,Area 9, Douda Avenue, Fangshan District, Beijing, 102433 China',
		text3: 'Registered Address: Room 100,Building C,NO.29 Life Park Rd,Changping District,Beijing,102206 China',
		text4: 'Associated Websites',
		text5: 'Copyright Coretests All rights reserved.',
		text6: 'Home',
		text7: 'Product Center',
	},
	index: {},
	product: {
		text0: 'Product Center',
		text1: 'Product Center',
		text2: 'Provide Affordable, Use-friendly & Precision diagnostic products for the world',
		text3: 'All Products',
		text4: 'Home',
		text5: 'Product Center',
		text6: 'View',
		text7: 'Screen',
		text8: 'Reset',
		text9: 'Please enter keywords',
		text10: 'Search',
		text11: 'Screen',
		text12: '应用场景',
		text13: '产品分类',
		text14: 'Reset',
		text15: 'Confirm',
		text16: '全选',
		text17: 'Product',
		text18: 'Contact Us',
		text19: 'Information',
		text20: 'Error',
	},
	about: {},
	news: {
		text0: 'News',
		text1: 'Home',
		text2: 'Recommended',
		text3: 'Prev: ',
		text4: 'Next: ',
		text5: 'Error',
	},
	support: {
		text0: 'Technical Support',
		text1: 'Technical Support',
		text2: 'Principles of Nature Science: Proven & It is currently impossible to verify the existence of authenticity.',
		text3: 'Home',
		text4: 'Recommended',
		text5: 'Prev: ',
		text6: 'Next: ',
		text7: 'Error',
	}
};

export default en